export default __webpack_public_path__ + "static/media/itinerary4_800.ec19c2c2.webp";